var Type;
(function (Type) {
    Type["producer"] = "producer";
    Type["consumer"] = "consumer";
})(Type || (Type = {}));
/**
 * Url builder for predefined websocket url
 */
export class WebsocketUrlBuilder {
    constructor(websocketUrl, topic, producerUrl = "", consumerUrl = "") {
        this.topic = topic;
        this.consumeTopic = this.generateConsumeTopic(topic);
        this.DASFConsumerURL = (consumerUrl ? consumerUrl : this.buildUrl(websocketUrl, this.consumeTopic)) + "/" + this.generateSubscriptionPrefix();
        this.DASFProducerURL = producerUrl ? producerUrl : this.buildUrl(websocketUrl, this.topic);
    }
    buildUrl(websocketUrl, topic) {
        return websocketUrl + "/" + topic;
    }
    generateConsumeTopic(topic) {
        return topic + "_" + this.generateRequestToken();
    }
    generateSubscriptionPrefix() {
        return "web-frontend-" + new Date().toISOString();
    }
    generateRequestToken() {
        return Math.random().toString(16).slice(2);
    }
}
/**
 * Default url builder for apache pulsar implementation based on host:port, namespace and topic
 */
export class DefaultDASFUrlBuilder {
    constructor(host, port, namespace, topic) {
        this.topic = topic;
        this.consumeTopic = this.generateConsumeTopic(topic);
        this.DASFConsumerURL = this.buildUrl(host, port, namespace, Type.consumer, this.consumeTopic);
        this.DASFProducerURL = this.buildUrl(host, port, namespace, Type.producer, this.topic);
    }
    buildUrl(host, port, namespace, type, topic) {
        let url = DefaultDASFUrlBuilder.BASE_DASF_URL
            .replace("%host%", host)
            .replace("%port%", port)
            .replace("%namespace%", namespace)
            .replace("%type%", type)
            .replace("%topic%", topic);
        if (type == Type.consumer) {
            // append subscription
            url += this.generateSubscriptionPrefix() + "?subscriptionType=Exclusive";
        }
        return url;
    }
    generateConsumeTopic(topic) {
        return topic + "_" + this.generateRequestToken();
    }
    generateSubscriptionPrefix() {
        return "web-frontend-" + new Date().toISOString();
    }
    generateRequestToken() {
        return Math.random().toString(16).slice(2);
    }
}
DefaultDASFUrlBuilder.BASE_DASF_URL = "ws://%host%:%port%/ws/v2/%type%/non-persistent/public/%namespace%/%topic%/";
export class DigitalEarthUrlBuilder extends DefaultDASFUrlBuilder {
    constructor(topic) {
        super(DigitalEarthUrlBuilder.HOST, DigitalEarthUrlBuilder.PORT, DigitalEarthUrlBuilder.NAMESPACE, topic);
    }
}
DigitalEarthUrlBuilder.HOST = "rz-vm154.gfz-potsdam.de";
DigitalEarthUrlBuilder.PORT = "8082";
DigitalEarthUrlBuilder.NAMESPACE = "digital-earth";
//# sourceMappingURL=DASFUrlBuilder.js.map